import React, { useEffect, useRef, useState } from 'react';
import { View, Text, StyleSheet, ActivityIndicator } from 'react-native';
import WizzeeLog from '../lib/wizzeeLog';

const CameraWrapper = ({ style, children }) => {
  const videoRef = useRef(null);
  const [status, setStatus] = useState('loading'); // loading, ready, error

  useEffect(() => {
    async function setupCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'user' }, // or 'environment' for back camera
          audio: false,
        });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          setStatus('ready');
        }
      } catch (err) {
        WizzeeLog.error("Camera access denied:", err);
        setStatus('error');
      }
    }

    setupCamera();

    // Cleanup: Stop the camera stream when component unmounts
    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        const tracks = videoRef.current.srcObject.getTracks();
        tracks.forEach(track => track.stop());
      }
    };
  }, []);

  return (
    <View style={[styles.container, style]}>
      {status === 'loading' && <ActivityIndicator color="#FFF" />}
      
      {status === 'error' && (
        <Text style={styles.errorText}>Camera Permission Denied</Text>
      )}

      <video
        ref={videoRef}
        autoPlay
        playsInline
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: status === 'ready' ? 'block' : 'none',
        }}
      />
      
      {/* This allows your UI buttons/overlays to sit on top of the video */}
      <View style={StyleSheet.absoluteFill}>
        {children}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#000',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  errorText: {
    color: 'white',
    textAlign: 'center',
    padding: 20,
  },
});

export default CameraWrapper;